import { VideoPlayer } from "./VideoPlayer";

export function GalleryItem({ medias = [], description }) {
  const renderMedia = (media, alt) => {
    if (!media || !media.url) return null;
    if (media.type === "video") {
      return (
        <VideoPlayer
          key={media.url}
          url={media.url}
          poster={media.poster}
          classNames={media.classNames}
          sound={media?.sound ?? false}
        />
      );
    }
    return (
      <img
        key={media.url}
        src={media.url}
        alt={alt}
        className={media.classNames}
        loading="lazy"
      />
    );
  };
  const validMedias = medias.filter(Boolean);

  return (
    <div className="gallery-item grid-twelve-cols-lg grid-four-cols-sm span-twelve-lg span-four-sm break-text">
      {validMedias.map((m, i) => renderMedia(m, `Gallery Item ${i + 1}`))}
      <p className={description?.classNames}>{description?.text ?? ""}</p>
    </div>
  );
}
